module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4RAoh"))).then(() => parcelRequire('ljYL6'));